import React, { FC, Fragment } from 'react';
import { ControlledInput, Section } from '../../../shared';
import { useTranslation } from 'react-i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const OrganisationPreferredPostalCodeInputs: FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    const {
        fields: preferredPostalCodes,
        append,
        remove,
    } = useFieldArray({
        control,
        name: 'preferredPostalCodes',
    });

    return (
        <Section title={t('preferredPostalCodes')}>
            {preferredPostalCodes.map((postalCode, index) => (
                <Fragment key={postalCode.id}>
                    <Stack direction="row" spacing={2}>
                        <ControlledInput name={`preferredPostalCodes.${index}`} label={t('postalCodeLabel')} required />
                        <IconButton aria-label="delete" onClick={() => remove(index)} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Fragment>
            ))}

            <Button onClick={() => append('')} color="secondary">
                + {t('addPreferredPostalCode')}
            </Button>
        </Section>
    );
};
